import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function TenableConnectForm({ onSubmit, guideMode }) {
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);
  const formInitialValues = {
    access_key: "",
    secret_key: "",
  };
  const formCheckoutSchema = yup.object().shape({
    access_key: yup.string().required("required"),
    secret_key: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="access_key"
                label="access_key"
                value={values.username}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.access_key && !!errors.access_key}
                helperText={touched.access_key && errors.access_key}
                autoComplete="off"
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="secret_key"
                label="secret_key"
                type={showSecret ? "text" : "password"}
                value={values.secret_key}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.secret_key && !!errors.secret_key}
                helperText={touched.secret_key && errors.secret_key}
                autoComplete="off"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
